import {cocktails} from "./src/Cocktails";

(function (Drupal) { // closure
    'use strict';

    // Cocktails
    Drupal.behaviors.cocktails = cocktails;
}(Drupal));
